import { AirportProvider } from '@place/ui/contexts'
import { ReviewCard } from '@place/ui/presets'

import { gql } from '@web/gql'
import { PlaceOtherReview_ReviewGroupFragment } from '@web/gql/graphql'
import { ContentProvider } from '@web/libs/contexts/ContentContext'
import { langVar } from '@web/libs/translate/translate.state'
import { ReviewEndArea, useReviewCardPropsForReviewEnd } from '@web/pages/review/components/ReviewDetail/useReviewCard'

import styles from './index.module.scss'

interface Props {
  reviewGroup: PlaceOtherReview_ReviewGroupFragment
}

const PlaceOtherReview = ({ reviewGroup }: Props) => {
  const lang = langVar()
  const reviewCardProps = useReviewCardPropsForReviewEnd(reviewGroup, ReviewEndArea.OTHERS)

  return (
    <ContentProvider id={reviewGroup.id} type={reviewGroup.__typename}>
      <AirportProvider locale={lang}>
        <ReviewCard className={styles.list_item} {...reviewCardProps} />
      </AirportProvider>
    </ContentProvider>
  )
}

PlaceOtherReview.fragments = {
  reviewGroup: gql(`
    fragment PlaceOtherReview_ReviewGroup on ReviewGroup {
      id
      rating
      exposeStatus
      reply {
        isQualified
      }
      place {
        id
        categoryIdPath
        type
      }
      ...ReviewStatusNotification_ReviewGroup
      ...OwnerReply_ReviewGroup
      ...ReviewDescription_ReviewGroup
      ...ReviewProfile_ReviewGroup
      ...MediaList_ReviewGroup
    }
  `),
}

export default PlaceOtherReview
